import TireModelForm from "@/modules/inventory/tire_management/components/forms/TireModelForm";

export const INVENTORY_ROUTES = [
    {
        path: "itemDetailsForm",
        name: "itemDetailsForm",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/items/components/forms/ItemDetailsForm")
    },
    {
        path: "inventoryOverviewLayout/:tabID?",
        name: "inventoryOverviewLayout",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/layouts/InventoryOverviewLayout")
    },

    {
        path: "purchaseOrderDetailsForm",
        name: "purchaseOrderDetailsForm",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/purchase_orders/forms/PurchaseOrderDetailsForm")
    },
    {
        path: "inventoryForm",
        name: "inventoryForm",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/components/forms/InventoryForm")
    },
    {
        path: "tireStoreForm",
        name: "tireStoreForm",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/tire_management/components/forms/TireStoreForm")
    },
    {
        path: "TireModelForm",
        name: "TireModelForm",
        component: TireModelForm
    },
    {
        path: "tireForm",
        name: "tireForm",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/tire_management/components/forms/TireForm")
    },
    {
        path: "tirePatternLayout",
        name: "tirePatternLayout",
        component: () =>
            import(/* webpackChunkName: "inventory" */ "@/modules/inventory/tire_management/layouts/TirePatternLayout")

    }
];
